<script lang="ts">
  import Data from "../../../components/Data.svelte";
  import { formatNumbersWithCommas } from "../../../helpers/string";
  import { clearWallet, ethereum } from "../../../store/ethereum";
  import { getContext, onDestroy } from "svelte";
  import ConnectModal from "../../../components/modals/ConnectModal.svelte";
  import ErrorModal from "../../../components/modals/ErrorModal.svelte";
  import {
    networkName,
    presaleContract,
  } from "../../../helpers/contracts";
  import { formatEther } from "@ethersproject/units";
  import TransactionModal from "../../../components/modals/TransactionModal.svelte";
  import type { Signer } from "@ethersproject/abstract-signer";

  const { open, close } = getContext("simple-modal");

  let balance = 0;
  $: connected = $ethereum.signer != undefined;
  $: getBalances($ethereum.signer);
  let timeout;
  let loading = false;

  onDestroy(() => {
    clearTimeout(timeout);
  });

  const getBalances = async (s: Signer) => {
    if (s == null) return;
    const purchasedBTS = await presaleContract($ethereum.chainId)
      .connect($ethereum.signer)
      .balanceOf($ethereum.address);
    balance = parseInt(formatEther(purchasedBTS));
  };

  const claim = async () => {
    if (!connected) return connectFirst();
    loading = true;

    const presale = await presaleContract($ethereum.chainId).connect(
      $ethereum.signer
    );

    try {
      const res = await presale.withdrawTokens($ethereum.address);
      open(TransactionModal, {
        message: "Claiming tokens. Please wait...",
        details: `TxHash: ${res.hash}`,
        hash: res.hash,
      });
      await res.wait();
      location.href = "/wallet";
    } catch (err) {
      close();
      let msg = err.toString();
      if (err.message && err.code)
        msg = `code: ${err.code}\nmessage: ${err.message} \ndata: ${err.data}`;
      open(ErrorModal, { message: "Claim failed", details: msg });
    }

    loading = false;
  };

  const connectFirst = () => {
    open(ConnectModal, {
      message:
        "You must connect your wallet before claiming. Set you wallet's network to either the Ethereum, or Arbitrum.",
    });
  };

  const disconnect = () => {
    clearWallet();
  };
</script>

<div class="network-info">
  <b>
    Wallet Network: {$ethereum.signer
      ? networkName($ethereum.chainId)
      : "Not Connected"}
  </b>
  <p>
    Supported Networks: Ethereum, Arbitrum (Low Fees).
    {#if $ethereum.signer != undefined}
      <button class="btn-link" on:click={disconnect}>disconnect</button>
    {:else}
      <button class="btn-link" on:click={connectFirst}>connect</button>
    {/if}
  </p>
</div>

<div class="network-info">
  <div class="presale">
    <div class="slider">
      <h2>$DOE Token Pre-Sale <br />(ended)</h2>

      <p>The pre-sale has ended, please claim your tokens below.</p>

      <div class="flex flex-big" style="justify-content: space-between;">

        <Data label="Claimable">
          {formatNumbersWithCommas(balance)}
        </Data>
      </div>

      <button
        class="connect_common_btn claimbtn"
        on:click={claim}
        disabled={loading}
      >
        {#if loading}
          Awaiting confirmation from wallet...
        {:else}
          Claim your DOE
        {/if}
      </button>
    </div>
  </div>

  {#if $ethereum.chainId != 1}
    <div class="help">
      <i class="fas fa-info-circle" />

      <b>
        We are aware some mobile wallet users are having trouble claiming their
        tokens on Arbitrum, we are working on resolving the issue with our node
        provider.
      </b>
      <br />
      <br />
      In the meantime you can claim your tokens on
      <a
        href="https://arbiscan.io/address/0xd8cdb4b17a741dc7c6a57a650974cd2eba544ff7#writeContract"
        >arbiscan.io</a
      >. Connect your wallet, then under <code>2.withdrawTokens</code> enter
      your
      <code>address</code> and write the transaction.
    </div>
  {/if}
</div>

<style>
  .claimbtn {
    font-weight: 600;
    font-size: 20px;
  }
  .network-info {
    padding: 20px;
    border-radius: 20px;
    background-color: #232539;
    color: #fff;
    margin-bottom: 30px;
  }

  .network-info p {
    margin-bottom: 0;
  }

  .network-info .btn-link {
    color: black;
    opacity: 0.7;
    font-size: 0.9rem;
  }

  .presale {
    max-width: 100%;
    padding: 40px;
    border-radius: 30px;
    background-color: #232539;
    color: white;
    width: 100%;
    display: flex;
    justify-content: space-between;
    font-size: 0.9rem;
    animation: buzz 1s ease-in-out;
    animation-iteration-count: infinite;
    animation-direction: alternate;
  }

  .help {
    margin: 40px auto;
    padding: 10px;
    font-size: 0.9rem;
    opacity: 0.7;
  }

  .presale input {
    width: 100%;
  }

  .slider {
    width: 100%;
    /* flex-basis: 50%;
    padding-right: 40px; */
  }

  .btn-large {
    margin-top: 20px;
    padding: 20px 30px;
    width: 100%;
    transition: transform 0.3s ease;
    flex-basis: 50%;
  }

  .btn-large:hover {
    transform: scale(1.02);
  }

  h2 {
    margin-top: 0.5rem;
    margin-bottom: 2rem;
  }

  a {
    color: var(--accent-color);
  }

  .balance {
    padding: 30px;
    padding-bottom: 0px;
    font-size: 0.9rem;
  }

  @keyframes buzz {
    0% {
      box-shadow: 0px 0px 0px 0px #232539;
    }

    /* 50% {
      box-shadow: 0px 0px 0px 0px rgba(0, 26, 255, 0.5);
    } */

    100% {
      box-shadow: 0px 0px 0px 20px #232539;
    }
  }

  @media screen and (max-width: 700px) {
    .card {
      padding: 0px;
      border-radius: 0px;
    }

    .presale {
      padding: 20px;
      animation: none;
      border-radius: 10px;
      box-shadow: 0px 0px 0px 1px var(--background);
    }

    .slider h2 {
      display: none;
    }

    .network-info {
      border-radius: 10px;
      padding: 10px;
    }
  }
</style>
